import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { PLACEMENT_POSITIONS } from '../../../../../Multiplatform/LineItemForms/fields'
import { placementPositionTitles } from '../../../../placements/helpers'

import { lineItemSelector } from '../../../../../../modules/selectors/lineItems'
import {
  AUDIENCE_NETWORK_CLASSIC,
  AUDIENCE_NETWORK_INSTREAM_VIDEO,
  AUDIENCE_NETWORK_REWARDED_VIDEO
} from '../../../../placements/fields'

const PlacementSectionPreview = () => {
  const { t } = useTranslation()

  const lineItem = useSelector(lineItemSelector)

  const { [PLACEMENT_POSITIONS]: placementPositions } = lineItem

  if (!placementPositions.length) {
    return null
  }

  return (
    <p>
      {t('Positions: ')}
      {placementPositions
        .map(position => {
          if (
            position === AUDIENCE_NETWORK_CLASSIC ||
            position === AUDIENCE_NETWORK_REWARDED_VIDEO ||
            position === AUDIENCE_NETWORK_INSTREAM_VIDEO
          ) {
            return t(`Audience network ${placementPositionTitles[position].toLowerCase()}`)
          }
          return t(placementPositionTitles[position])
        })
        .join(', ')}
    </p>
  )
}

export default PlacementSectionPreview
